export default "__VITE_ASSET__69e63422__"